import { TFunction } from 'i18next';
import { sumBy } from 'lodash';
import { EMPTY_VALUE } from 'shared/constants';
import { formatNumber } from 'shared/utils';
import { CountryData } from 'store/countriesDataStore';
import {
  MustHaveIds,
  OptionalIds,
} from 'shared/components/EstimatedBudgetsTable/types';
import { Currencies } from '../../shared/types';
import formatNumberOrDash from './helpers/formatNumberOrDash';

export default (
  filteredData: CountryData['estimatedBudget'],
  isMustHave: boolean,
  columnNames: string[],
  t: TFunction<'translation', undefined, 'translation'>,
  countryCurrency: Currencies,
  exchangeRates: any,
  mustHaveIds: MustHaveIds,
  optionalIds: OptionalIds
) => {
  const pickedFiltered = filteredData.filter((x) => {
    if (x.isMustHave !== isMustHave) return false;

    return isMustHave ? mustHaveIds[x.id] === true : optionalIds[x.id] === true;
  });

  const exchangeRate =
    countryCurrency !== 'EUR'
      ? exchangeRates?.data?.exchangeRates?.find((rate: any) =>
          rate.name.toLowerCase().includes(countryCurrency.toLowerCase())
        )?.value
      : null;

  return [
    isMustHave ? t('budgetMustHave') : t('optionalTouchpoints'),
    formatNumberOrDash(sumBy(pickedFiltered, 'budget')),
    exchangeRate
      ? formatNumberOrDash(sumBy(pickedFiltered, 'budget') * exchangeRate)
      : 'N/A',
    formatNumber(sumBy(pickedFiltered, columnNames[0])),
    EMPTY_VALUE,
    formatNumber(sumBy(pickedFiltered, columnNames[2])),
    formatNumber(sumBy(pickedFiltered, columnNames[3])),
    EMPTY_VALUE,
  ];
};
